import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

const [useMigrateSpace, migrateSpace] = createAsyncAction(
  "spaces/createSpace",
  async (spaceId: number) => {
    const res = await API.call<{ space: number }>({
      endpoint: `spaces/${spaceId}/migrate`,
      method: "POST",
    });
    return { ...res, result: res.result.space };
  }
);

export default useMigrateSpace;
export { migrateSpace };
